import { AggregatorsResponse_Aggregator } from '../../../pb/responses/v1/aggregators_response_pb';
import { CountryWithProviders } from './Country';
import { PackageProvider } from './PackageProvider';

/**
 * A provider-shaped stand-in for an aggregator, carrying along the aggregator it was resolved
 * from and the individual carriers it collapses (e.g. Kvikk's own gls/dpd/packeta/...) — so a
 * consumer that needs to go back to either doesn't have to redo the lookup/grouping.
 */
export interface AggregatorPackageProvider extends PackageProvider {
    aggregator: AggregatorsResponse_Aggregator;
    providers: PackageProvider[];
}

/**
 * A CountryWithProviders whose `packageproviders` may hold an AggregatorPackageProvider stand-in
 * in place of the individual carriers it collapses.
 */
export type CountryWithAggregatedProviders = Omit<CountryWithProviders, 'packageproviders'> & {
    packageproviders: (PackageProvider | AggregatorPackageProvider)[];
};

export const isAggregatorPackageProvider = (
    provider: PackageProvider | AggregatorPackageProvider
): provider is AggregatorPackageProvider => 'providers' in provider;
